var map = {
	"./0.jpg": 83,
	"./1.jpg": 84,
	"./10.jpg": 85,
	"./11.jpg": 86,
	"./2.jpg": 87,
	"./3.jpg": 88,
	"./4.jpg": 89,
	"./5.jpg": 90,
	"./6.jpg": 91,
	"./7.jpg": 92,
	"./8.jpg": 93,
	"./9.jpg": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;